import { isEmpty } from './multiselect-helper.js';

var PendoMultiselectProps = {
  props: {
    name: {
      type: String,
      default: ''
    },
    showSelectedValues: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 99999
    },
    limitText: {
      type: Function,
      default: count => `and ${count} more`
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableWhileLoading: {
      type: Boolean,
      default: true
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    noResultsText: {
      type: String,
      default: 'No options found. Consider changing the search query.'
    },
    showMaxElements: {
      type: Boolean,
      default: true
    },
    allSelectedText: {
      type: String,
      default: 'All available options selected.'
    },
    formatOptionLabel: {
      type: Function,
      default(option, labelKey) {
        if (isEmpty(option)) {
          return '';
        }
        return typeof option === 'object' ? option[labelKey] : option;
      }
    },
    internalSearch: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: () => []
    },
    optionHeight: {
      type: Number,
      default: 26
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Object, Array, String, Number],
      default: () => []
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    searchable: {
      type: Boolean,
      default: null
    },
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    hideSelectedOptions: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: [String, Number],
      default: 'Select option'
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    stateless: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    taggable: {
      type: Boolean,
      default: false
    },
    isValidNewOption: {
      type: Function,
      default: undefined
    },
    tagPlaceholder: {
      type: String,
      default: null
    },
    tagPosition: {
      type: String,
      default: 'top'
    },
    max: {
      type: [Number, Boolean],
      default: false
    },
    id: {
      type: [String, Number],
      default: null
    },
    blockKeys: {
      type: Array,
      default: () => []
    },
    preserveSearch: {
      type: Boolean,
      default: false
    },
    preselectFirst: {
      type: Boolean,
      default: false
    },
    showPointer: {
      type: Boolean,
      default: true
    },
    groupOptionsKey: {
      type: String,
      default: 'options'
    },
    groupLabelKey: {
      type: String,
      default: 'label'
    },
    groupSelect: {
      type: Boolean,
      default: false
    },
    groupDividers: {
      type: Boolean,
      default: true
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    minTriggerWidth: {
      type: [String, Number],
      default: 160
    },
    maxTriggerWidth: {
      type: [String, Number],
      default: 400
    },
    minMenuWidth: {
      type: [String, Number],
      default: 160
    },
    maxMenuWidth: {
      type: [String, Number],
      default: 400
    },
    maxMenuHeight: {
      type: [String, Number],
      default: 302
    },
    triggerSize: {
      type: String,
      default: 'medium',
      validator: triggerSize => ['mini', 'small', 'medium'].includes(triggerSize)
    },
    searchThreshold: {
      type: [Number, Boolean],
      default: 10
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    popperOptions: {
      type: Object,
      default: () => ({})
    },
    labels: {
      type: Object,
      default: () => ({})
    },
    extraLabelWidth: {
      type: Number,
      default: 40
    },
    invalid: {
      type: Boolean,
      default: false
    },
    sortBy: {
      type: [String, Function],
      default: null
    },
    sortMethod: {
      type: Function,
      default: null
    },
    scrollConfig: {
      type: Object,
      default() {
        return {
          enabled: true
        };
      }
    }
  }
};

export { PendoMultiselectProps as default };
//# sourceMappingURL=pendo-multiselect-props.js.map
